import React from "react";
import {observer} from "mobx-react";
import {ComponentPropsFromRoute} from "../../../../routers/routers";
import {RouteButtons} from "../../../common/route-tabs/route.buttons";

export const AgentDataGeneral: React.FC<ComponentPropsFromRoute> = observer(({routeChildren}) => {
    return <RouteButtons routes={routeChildren || []} withoutRootTabPath={true} />
});
